import { Phone, Mail } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal, Eyebrow } from "@/components/site/motion";
import { ContactForm } from "@/components/site/ContactForm";
import { Notice112 } from "@/components/site/Notice112";
import { PHONE, PHONE_HREF, PARTNER_EMAIL, PEC } from "@/data/site";

const Item = ({ icon: I, label, children }) => (
  <div className="flex items-start gap-4 border-b border-navy/10 py-6">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/50"><I className="h-4 w-4 text-gold-ink" strokeWidth={1.6} /></span>
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate2">{label}</p>
      <div className="mt-1.5">{children}</div>
    </div>
  </div>
);

export default function Contatti() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contatti"
        lines={["Parliamo della", "tua esigenza."]}
        intro="Compila il modulo o chiama la Centrale Operativa. Ogni richiesta merita attenzione, competenza e una risposta organizzata."
      />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.6fr] lg:gap-20">
          <div>
            <Reveal>
              <a href={PHONE_HREF} data-testid="contact-phone-card" className="group block overflow-hidden rounded-[24px] bg-navy p-8 text-white">
                <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">Centrale Operativa · telefono diretto</p>
                <p className="mt-4 text-3xl font-semibold tracking-tight md:text-4xl">{PHONE}</p>
                <p className="mt-6 inline-flex items-center gap-2 text-sm text-white/80 transition-colors group-hover:text-gold">
                  <Phone className="h-4 w-4" strokeWidth={1.6} /> Tocca per chiamare
                </p>
              </a>
            </Reveal>
            <Reveal delay={0.1}>
              <Item icon={Mail} label="Rete partner">
                <a href={`mailto:${PARTNER_EMAIL}`} className="text-base font-semibold text-navy hover:text-gold-ink" data-testid="contact-partner-email">{PARTNER_EMAIL}</a>
              </Item>
              <Item icon={Mail} label="PEC">
                <a href={`mailto:${PEC}`} className="text-base font-semibold text-navy hover:text-gold-ink" data-testid="contact-pec">{PEC}</a>
              </Item>
            </Reveal>
          </div>
          <div id="modulo" className="scroll-mt-28" data-testid="contact-form-section">
            <Reveal><Eyebrow>Modulo di richiesta</Eyebrow></Reveal>
            <Reveal delay={0.1}><h2 className="mb-10 mt-5 text-3xl font-semibold text-navy md:text-4xl">Inviaci la tua richiesta</h2></Reveal>
            <ContactForm />
          </div>
        </div>
      </section>
      <section className="bg-white pb-20 md:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8"><Notice112 /></div>
      </section>
    </div>
  );
}
